import type { EventHandler, SyntheticEvent } from 'react';

export const mergeEventHandlers =
  (...handlers: EventHandler<SyntheticEvent>[]): EventHandler<SyntheticEvent> =>
  (event) => {
    handlers.forEach((handler) => {
      handler && handler(event);
    });
  };
